import { defineComponent as _defineComponent } from 'vue';
import { faCog, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BDropdown, BDropdownForm, BDropdownItemButton, BFormCheckbox } from "bootstrap-vue";
//@ts-ignore deprecated package without types (vue 2, remove this comment on vue 3 migration)
import { ArrowLeftFromLine, ArrowRightToLine } from "lucide-vue";
import { computed } from "vue";
import { useWorkflowNodeInspectorStore } from "@/stores/workflowNodeInspectorStore";
import FormDefault from "./Forms/FormDefault.vue";
import FormTool from "./Forms/FormTool.vue";
import DraggableSeparator from "@/components/Common/DraggableSeparator.vue";
import Heading from "@/components/Common/Heading.vue";
import IdleLoad from "@/components/Common/IdleLoad.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NodeInspector',
    props: {
        step: null,
        datatypes: null
    },
    emits: ["postJobActionsChanged", "annotationChanged", "labelChanged", "dataChanged", "stepUpdated", "editSubworkflow", "attemptRefactor", "close"],
    setup(__props, { emit }) {
        const props = __props;
        const inspectorStore = useWorkflowNodeInspectorStore();
        const maximized = computed(() => inspectorStore.maximized(props.step));
        const width = computed(() => inspectorStore.width(props.step));
        const cssVars = computed(() => ({
            "--width": `${width.value}px`,
        }));
        const isTool = computed(() => props.step.type === "tool");
        const title = computed(() => { var _a; return `${props.step.id + 1}: ${(_a = props.step.label) !== null && _a !== void 0 ? _a : props.step.name}`; });
        function close() {
            inspectorStore.generalMaximized = false;
            emit("close");
        }
        return { __sfc: true, props, emit, inspectorStore, maximized, width, cssVars, isTool, title, close, faCog, faTimes, FontAwesomeIcon, BButton, BButtonGroup, BDropdown, BDropdownForm, BDropdownItemButton, BFormCheckbox, ArrowLeftFromLine, ArrowRightToLine, FormDefault, FormTool, DraggableSeparator, Heading, IdleLoad };
    }
});
